module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB1526-12fa207b48bfbca983fd8def1ca40b72.png";